import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { setFlowForACQ143 } from '../../experiments/acq0143/ACQ143Utils';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getIsExistingUserSession } from '../../store/app/selectors';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getStepConfig } from '../../views/getStepConfig';
export const BranchACQ143 = {
  name: 'BranchACQ143',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0143, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const stepConfig = getStepConfig(Step.HubletSelection);
    if (stepConfig) {
      stepConfig.showNextButtonIcon = false;
    }
    const nextSteps = dispatch(setFlowForACQ143({
      isPreVerificationExistingUserSession: getIsExistingUserSession(state) && isPreVerification()
    }));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};